import { SUPPORTED_RESOURCE_CONTENT_TYPES } from '@module/mdrt-org/shared/utils/data/constants/content-type';

export const getValidContentType = (candidateType: null | string | undefined): null | number => {
  const parsedCandidateType = Number(candidateType);

  if (parsedCandidateType === 0) {
    return null;
  }

  if (SUPPORTED_RESOURCE_CONTENT_TYPES.includes(parsedCandidateType)) {
    return parsedCandidateType;
  }

  return null;
};
